module.exports = __webpack_public_path__ + "img/fa.207e8ba0.webp";